import { useEffect } from "react";
import { ColoringFlower } from "@/components/ColoringFlower";
import { ResourceNotice, PrintBar } from "@/components/ResourceNotice";
import { LEVELS } from "@/lib/heat";

const ranges = ["0–11", "12–20", "21–28", "29–36"];

export function useResourcePrint() {
  useEffect(() => {
    document.body.classList.add("resource-print");
    return () => document.body.classList.remove("resource-print");
  }, []);
}

export default function ColoringSheet() {
  useResourcePrint();
  return (
    <div className="resource-doc mx-auto max-w-[8.5in]" data-testid="coloring-sheet">
      <PrintBar title="Color Your Flower sheet" />
      <ColoringSheetContent />
    </div>
  );
}

export const ColoringSheetContent = () => {
  return (
    <>
      <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm print-plain">
        <div className="flex items-center gap-3">
          <img src="/flower-logo.png" alt="" className="h-10 w-10" />
          <div>
            <div className="text-[11px] font-mono uppercase tracking-widest text-slate-500">Minister's Helper · DIY Heat Map</div>
            <h1 className="font-display text-2xl font-bold text-slate-900">Color Your Flower</h1>
          </div>
        </div>
        <p className="mt-3 text-sm text-slate-600">
          Write your score for each area next to its petal. Then color each petal from the center outward up to your score: the
          center is 0 and the petal tip is 36. The dashed rings mark the top score of each level (11, 20, 28 and 36). Use the level colors below, or any
          colors you like.
        </p>
        <div className="mt-2 flex justify-center">
          <ColoringFlower size={520} />
        </div>
        <div className="mt-2 grid grid-cols-4 gap-2" data-testid="coloring-levels">
          {LEVELS.map((l, i) => (
            <div key={l.label} className="rounded-lg border border-slate-200 p-2 text-center">
              <div className="mx-auto h-3 w-10 rounded" style={{ background: l.hex }} />
              <div className="mt-1 text-xs font-semibold text-slate-800">{l.label}</div>
              <div className="text-[11px] text-slate-500">{ranges[i]}</div>
            </div>
          ))}
        </div>
        <div className="mt-3 grid grid-cols-2 gap-x-6 text-sm text-slate-700">
          <div>Name: ______________________________</div>
          <div>Date: ______________________________</div>
        </div>
        <ResourceNotice showQr />
      </section>
    </>
  );
};
